import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { ATTESTATIONS, SEND_COPY } from '../../sendOrchestration.constants';
import { cardHintStyles, cardStyles, cardTitleStyles } from '../../SendStep.styles';
import { SendStepTestIds } from '../../SendStep.testIds';
import AttestationCheckItem from '../AttestationCheckItem';

const AttestationsCard = ({ attestations, disabled, onToggle }) => (
  <Box data-testid={SendStepTestIds.ATTESTATIONS} sx={cardStyles}>
    <Typography sx={cardTitleStyles} variant="bold12">
      {SEND_COPY.attestationsTitle}
    </Typography>
    {ATTESTATIONS.map(attestation => (
      <AttestationCheckItem
        attestation={attestation}
        checked={!!attestations[attestation.type]}
        disabled={disabled}
        key={attestation.type}
        onToggle={onToggle}
      />
    ))}
    <Typography sx={cardHintStyles} variant="regular12">
      {SEND_COPY.attestationsHint}
    </Typography>
  </Box>
);

AttestationsCard.propTypes = {
  attestations: PropTypes.objectOf(PropTypes.bool).isRequired,
  onToggle: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default memo(AttestationsCard);
